
import { mapGetters } from "vuex";

export default {
  props: {
    selectedVariant: { type: Object, default: () => {} },
  },

  async fetch() {
    let payload = [this.selectedVariant]
      .map(({ sku, price }) => ({
        sku,
        price: price * 100,
        quantity: 1,
      }))
      .filter(({ sku }) => Boolean(sku));

    await this.$store.dispatch("velocity/fetchVelocityPoints", payload);
  },

  fetchOnServer: false,

  computed: {
    ...mapGetters("velocity", ["getVelocityPoints", "getVelocityBonusPoints"]),
    velocityPoint() {
      return this.getVelocityPoints(this.selectedVariant);
    },
    bonusPoints() {
      return this.getVelocityBonusPoints(this.selectedVariant);
    },
  },

  watch: {
    selectedVariant() {
      this.$fetch();
    },
  },
};
